import React from 'react';
import './pattuglia.css';
import pattuglia3 from '../resources/images/pattuglia3.jpg'
import Header from '../components/menu/header';

const Pattuglia = () => {
  return (
    <div className="pattuglia-page">
      <Header />
      {/* Hero - Ideale */}
      <section className="hero-section">
        <div className="hero-container">
          <h1 className="hero-title">
            Scontrandosi ed <span className="hero-highlight">Incontrandosi</span><br></br> su un campo da Scoutball! 
          </h1>
        </div>
      </section>

      {/* Valori */}
      <section id="valori" className="values-section">
        <div className="values-container">
          <div className="values-header">
            <h2 className="values-title">Perché giochiamo?</h2>
          </div>
          
          <div className="values-grid">
            <div className="value-card value-card-blue">
              <div className="value-card-header">
                <div className="value-icon value-icon-blue">
                  <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="value-title">Patto Associativo - Gioco</h3>
              </div>
              <p className="value-description">
                Il gioco è un momento educativo in cui, attraverso l'avventura, l'impegno e la scoperta, il ragazzo sviluppa creativamente tutte le proprie doti, cogliendo meglio limiti e capacità personali, impara a riconoscere le regole e a rispettarle con lealtà. È una costante e progressiva esperienza della comune aspirazione alla gioia, dispone all'entusiasmo, al senso del gratuito, all'apertura al nuovo, alla ripresa fiduciosa dopo ogni insuccesso, all'accettazione e al completamento reciproco. 
              </p>
            </div>
            
           <div className="value-card value-card-orange">
              <div className="value-card-header">
                <div className="value-icon value-icon-orange">
                  <svg className="icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="value-title">Perchè giochiamo?</h3>
              </div>
              <p className="value-description">
                La vera domanda che ci dobbiamo porre non è "peché giochiamo a scoutball?", ma semplicemente "perché giochiamo?".<br></br>
                La nostra risposta è che è le Comunità non si forgiano direttamente tramite esperienze comuni, ma emozioni comuni. E sono proprio quelle emozioni che il gioco genera, ogni tanto di gioia nell'alzare una coppa, ogni tanto di delusione non vedendo il proprio nome avanzare lungo il tabellone che forgiano un gruppo, una Comunità. Il gioco è un mezzo, non un fine. Crediamo che il gioco, anche per adulti, sia una parte fondamentale dell'educazione scout. <br></br>
                È stato scelto lo scoutball come gioco perché rappresenta, fin dal nome, un po' tutti. E' uno sport completo, con una storia, un tradizione. E' un gioco di squadra, dove si vince insieme e si perde inseme, dove non contano i personalismi ma solo il successo del gruppo.<br></br>
                Ma il filo conduttore che ha guidato tutto questo e che continuerà ad essere la nostra stella polare non è tanto fare il torneo più grande, l'evento più "fico", ma piuttosto uniformare e stilare un regolamento veramente unitario, in modo che un "Padova 5" possa giocare contro un "Palermo 20" secondo le stesse regole e gli stessi valori.<br></br>
                <b>Scontrandosi ed Incontrandosi su un campo da Scoutball!</b>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Storia */}
      <section id="storia" className="history-section">
        <div className="history-container">
          <h2 className="history-title">La nostra Storia</h2>
          
          <div className="timeline">
            <div className="timeline-line"></div>
            
            <div className="timeline-events">
              <div className="timeline-event">
                <div className="timeline-marker timeline-marker-green">
                  <span>1974</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-event-title">Le Origini</h3>
                  <p className="timeline-event-description">
                    Le prime tracce di un regolamente che possa assomigliare a quello odierno si trovano in un documento del 7° Campo Nazionale ASCI, del 1974, che a sua volta si ri fà su un regolamento proveniente dal CNGEI di Reggio Emilia
                    Lo scoutball esiste solo sulla carta, con regole diverse ovunque. C'è chi gioca con la palla, chi senza; alcuni hanno lo scalpo altri no
                  </p>
                </div>
              </div>

              <div className="timeline-event">
                <div className="timeline-marker timeline-marker-blue">
                  <span>2003</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-event-title">Gli Amanti dello Scoutball</h3>
                  <p className="timeline-event-description">
                    Nasce a Bologna la prima strutturazione del gioco con tornei per promuovere lo scoutball come Gioco tra gli scout di tutta Italia unificando i regolamenti
                  </p>
                </div>
              </div>

              <div className="timeline-event">
                <div className="timeline-marker timeline-marker-orange">
                  <span>2007</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-event-title">Primo Torneo Nazionale</h3>
                  <p className="timeline-event-description">
                    32 squadre, 500 partecipanti da tutta Italia per il centenario dello scoutismo. 
                    Un evento che ha portato i valori scout attraverso il gioco.
                  </p>
                </div>
              </div>

              <div className="timeline-event">
                <div className="timeline-marker timeline-marker-green-dark">
                  <span>2010</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-event-title">Pattuglia Scoutball</h3>
                  <p className="timeline-event-description">
                    Nasce ufficialmente la Pattuglia Scoutball con il "patto di collaborazione" tra la Zona di Bologna e gli AdS, che entra a far parte della Zona come Pattuglia
                  </p>
                </div>
              </div>

              <div className="timeline-event">
                <div className="timeline-marker timeline-marker-blue">
                  <span>2016</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-event-title">La famiglia si allarga</h3>
                  <p className="timeline-event-description">
                    La Pattuglia quindi decide di riformare gli AdS per organizzare tornei in giro per lo stivale. L'idea non è quella di fare un passo indietro rispetto l'entrata in Zona ma, proprio in virtù dell'esperienza maturata durante questo lungo percorso, farsi promotrice di nuovi tornei in modo che anche altre Zone possano conoscere e cimentarsi in questo gioco che ci rappresenta come scout.<br></br>
                    Nascono le pattuglie di Brescia, Padova e La Spezia.
                  </p>
                </div>
              </div>

              <div className="timeline-event">
                <div className="timeline-marker timeline-marker-orange">
                  <span>2022</span>
                </div>
                <div className="timeline-content">
                  <h3 className="timeline-event-title">Siamo sempre di più</h3>
                  <p className="timeline-event-description">
                    Nascono le Pattuglie di Ancona e Prealpina
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Oggi */}
      <section id="oggi" className="today-section">
        <div className="today-container">
          <div className="today-header">
            <h2 className="today-title">Le Pattuglie Oggi</h2>
          </div>

          <div className="today-content">
            <img src={pattuglia3} className="memorial-card-photo"/>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Pattuglia;